export enum CommonDataSourceUID {
    COUNTRY = "country",
    CURRENCY = "currency"
}